import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { setPageTitle } from 'actions/header';
import { getNotifications } from 'actions/notifications';
import { getActiveLanguage, translate } from '@haldor/ui';
import { Spinner } from 'UI';
import sniffer from 'sniffer';
import Alert from 'components/Presentation/Notifications/Alert';
import FromNow from "components/Presentation/Dates/FromNow";
var Notifications = /*#__PURE__*/function (_Component) {
  function Notifications() {
    var _this;
    _classCallCheck(this, Notifications);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Notifications, [].concat(args));
    _defineProperty(_this, "UNSAFE_componentWillMount", function () {
      _this.props.setPageTitle(_this.props.translate('Events'));
      _this.props.getNotifications();
    });
    _defineProperty(_this, "componentDidUpdate", function (prevProps) {
      if (prevProps.language != _this.props.language) {
        _this.props.getNotifications();
      }
    });
    return _this;
  }
  _inherits(Notifications, _Component);
  return _createClass(Notifications, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      if (this.props.notifications == null) {
        return /*#__PURE__*/React.createElement("div", {
          className: "app-comp-content content"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "overview"
      }, /*#__PURE__*/React.createElement("div", {
        className: "section latest",
        style: {
          margin: 0,
          padding: 0,
          border: 0
        }
      }, this.props.notifications.map(function (notification, i) {
        var student = _this2.props.students.find(function (student) {
          return student.id == notification.studentId;
        });
        if (notification.referenceUrl !== null) {
          return /*#__PURE__*/React.createElement(Link, {
            to: "/notificationReceiver?url=".concat(notification.referenceUrl, "&studentId=").concat(notification.studentId, "&notificationId=").concat(notification.id),
            key: i,
            className: "notificationsLink"
          }, /*#__PURE__*/React.createElement(Alert, {
            id: i,
            type: "news",
            key: i
          }, /*#__PURE__*/React.createElement("span", {
            className: "news-title"
          }, !notification.contentRead ? /*#__PURE__*/React.createElement("div", {
            className: "unread-container",
            style: sniffer.isDevice ? {
              alignItems: 'flex-start',
              marginTop: '6px'
            } : {}
          }, /*#__PURE__*/React.createElement("span", {
            className: "unread-dot"
          })) : null, student != null ? student.firstName + ' ' + student.lastName + ': ' : null, notification.notificationText), /*#__PURE__*/React.createElement("div", {
            className: "alert-timestamp"
          }, /*#__PURE__*/React.createElement(FromNow, {
            utc: true
          }, notification.created))));
        }
        return /*#__PURE__*/React.createElement(Alert, {
          id: i,
          type: "news",
          key: i
        }, /*#__PURE__*/React.createElement("span", {
          className: "news-title"
        }, !notification.contentRead ? /*#__PURE__*/React.createElement("div", {
          className: "unread-container",
          style: sniffer.isDevice ? {
            alignItems: 'flex-start',
            marginTop: '6px'
          } : {}
        }, /*#__PURE__*/React.createElement("span", {
          className: "unread-dot"
        })) : null, student != null ? student.firstName + ' ' + student.lastName + ': ' : null, notification.notificationText), /*#__PURE__*/React.createElement("div", {
          className: "alert-timestamp"
        }, /*#__PURE__*/React.createElement(FromNow, {
          utc: true
        }, notification.created)));
      })));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    notifications: state.Notifications.notifications,
    students: state.guardians.students,
    language: getActiveLanguage()
  };
}
export default connect(mapStateToProps, {
  setPageTitle: setPageTitle,
  getNotifications: getNotifications
})(Notifications);